import React from 'react';
import { Form, Input, Button, Icon, Checkbox, Transfer, Tree, Select } from 'antd';
import { User } from '../../../../models';
import TextArea from 'antd/lib/input/TextArea';
import { Text3 } from '../../../../styles';
import { useState } from 'react';
import './index.scss';
import { PERMISSION_CATEGORY } from '../../../../constants';


let UserPermissionForm = (props) => {
    const { form, user, users, permissions, cloneUsers, is_reseller } = props;
    const { getFieldDecorator } = form;
    const validations = User.validations;

    const allPermissions = permissions.map(permission => permission.slug);

    const [targetKeys, setTargetKeys] = useState(props.user.permissions);


    const { TreeNode } = Tree;


    const isChecked = (selectedKeys, eventKey) => {
        return selectedKeys.indexOf(eventKey) !== -1;
    };

    const generatePermissionData = () => {
        var flags = [], output = [], i,j;
        var permissionList = []
        for( i=0; i<permissions.length; i++) {
            if( flags[permissions[i].category]) continue;
            flags[permissions[i].category] = true;
            output.push(permissions[i].category);
        }
        for(i=0; i<output.length; i++){
            var data = { key: '', title: PERMISSION_CATEGORY[output[i]], checkable: false, selectable: false, children:[]};
            for (j=0;j<permissions.length;j++){
            if(permissions[j].category==output[i]){
            if(!is_reseller && ['MERCHANTS_COMMISSION', 'MERCHANTS_INSIGHTS', 'SETTINGS_WRITE_WHITE_LABEL'].includes(permissions[j].slug)) continue;
            else
            data.children.push({key: permissions[j].slug, title: permissions[j].name});
            }
            }
            permissionList.push(data);
        }
        return permissionList;
    }
    const generateTree = (treeNodes = [], checkedKeys = []) => {
        return treeNodes.map(({ children, ...props }) => (
            <TreeNode {...props} disabled={checkedKeys.includes(props.key)} key={props.key}>
                {generateTree(children, checkedKeys)}
            </TreeNode>
        ));
    };

    const TreeTransfer = ({ dataSource, targetKeys, ...restProps }) => {
        const transferDataSource = [];
        function flatten(list = []) {
            list.forEach(item => {
                transferDataSource.push(item);
                flatten(item.children);
            });
        }
        flatten(dataSource);
        return (
            <Transfer
                {...restProps}
                targetKeys={targetKeys}
                dataSource={transferDataSource}
                className="tree-transfer"
                render={item => item.title}
                showSelectAll={false}
            >
                {({ direction, onItemSelect, selectedKeys }) => {
                    if (direction === 'left') {
                        const checkedKeys = [...selectedKeys, ...targetKeys];
                        return (
                            <Tree
                                blockNode
                                checkable
                                checkStrictly
                                checkedKeys={checkedKeys}
                                onCheck={(
                                    _,
                                    {
                                        node: {
                                            props: { eventKey },
                                        },
                                    },
                                ) => {
                                    onItemSelect(eventKey, !isChecked(checkedKeys, eventKey));
                                }}
                                onSelect={(
                                    _,
                                    {
                                        node: {
                                            props: { eventKey },
                                        },
                                    },
                                ) => {
                                    onItemSelect(eventKey, !isChecked(checkedKeys, eventKey));
                                }}
                            >
                                {generateTree(dataSource, targetKeys)}
                            </Tree>
                        );
                    }
                }}
            </Transfer>
        );
    };
    const onSubmit = (e) => {
        e.preventDefault();
        const values = form.getFieldsValue();
        values.permissions = targetKeys;
        props.onSubmit(values);
    };

    const onChange = (targetKeys, direction, moveKeys) => {
        if(direction == 'left'){
            const rm_key = []
            const keys = moveKeys.map((key) =>{
                const remove_keys = permissions.filter(permission => permission.dependent_permission.includes(key)).map(filter_permission => filter_permission.slug);
                rm_key.push(...remove_keys);
            });
            const value = targetKeys.filter(filter_key => !rm_key.includes(filter_key))
            setTargetKeys(value);
        }
        else{
         const keys = moveKeys.map((key) =>{
                const add_keys = permissions.filter(permission => permission.slug == key).map(filter_permission => filter_permission.dependent_permission);
                if(add_keys.length != 0){
                targetKeys.push(...add_keys[0])
                }
            });
            setTargetKeys(targetKeys);
        }
    };

    const selectAll = (e) => {
        if(e.target.checked){
            setTargetKeys(allPermissions);
        }
        else{
        setTargetKeys([]);
        }
    }

    const cloneResult = (value) =>{
        const selected_user = cloneUsers.filter(user => { return user.id === value})[0];
        setTargetKeys(selected_user.permissions)
    }

    const renderBasicForm = () => {
        return (
            <div>
                <div className="row mb-2">
                    <div className="col text-right">
                        <Checkbox onChange={selectAll}>Select All</Checkbox>
                        <Select placeholder="Clone Permissions" showSearch style={{ width: 200, marginLeft: 10 }} onChange={cloneResult}>
                        {
                            cloneUsers.map((usr, index) => <Select.Option key={index} value={usr.id}>{usr.name}</Select.Option>)
                        }

                </Select>
                    </div>
                </div>
                <div>
                    {getFieldDecorator("id", {
                        initialValue: user.id,
                        rules: validations.id
                    })(<Input autoComplete='off' hidden />)}
                    <TreeTransfer dataSource={generatePermissionData()} targetKeys={targetKeys} onChange={onChange} />
                </div>
            </div>
        )
    };

    return (
        <Form onSubmit={onSubmit}>
            <div className="row">
                <div className="col-sm">{renderBasicForm()}</div>
            </div>
            <div className="w-100 d-flex justify-content-end mt-4">
                <Button type="primary" htmlType="submit" loading={props.loading}>Update</Button>
            </div>
        </Form>
    )
};

UserPermissionForm = Form.create()(UserPermissionForm);
export { UserPermissionForm };